let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8u6e4")).then(() => parcelRequire('8kSz9'));